import { temAcesso } from '@/shared/auth/temAcesso'

const Solicitacoes = () => import('./Solicitacoes.vue')
const Solicitacao = () => import('./Solicitacao.vue')

export default {
    path: 'solicitacoes',
    name: 'AppSebrae_Consultorias_Fornecedor_Solicitacoes',
    component: Solicitacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('APPSE-FORN-CONS-00')) {
            next()
        }
    },
    children: [
        {
            path: ':consultoriaId',
            name: 'AppSebrae_Consultorias_Fornecedor_Solicitacoes_Detalhar',
            component: Solicitacao,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-FORN-CONS-00')) {
                    next()
                }
            }
        }
    ]
}
